import ModusServiceModel from "../ModusServiceModel";
import DepthReferenceCollection from "@/collections/modus/DepthReferenceCollection";

export default class DepthUnitModel extends ModusServiceModel {
  modelName() {
    return 'depth-units';
  }
  icon() {
    return 'ruler-triangle';
  }
  defaults() {
    return {
      id: null,
      name: null,
      abbr: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      depth_references: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      abbr: (val) => (this.nullStringMutator(val)),
      position: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getDepthReferences() {
    return this.getRelatedCollection(new DepthReferenceCollection(), 'depth_references');
  }
}
